/**
 * reCAPTCHA Utility Functions
 * Handles environment-based reCAPTCHA site key selection
 */

/**
 * Detects if the current environment is localhost/development
 * @returns {boolean} true if running on localhost
 */
export const isLocalhost = () => {
  if (typeof window === "undefined") {
    // Server-side: only consider localhost if NODE_ENV is development
    return process.env.NODE_ENV === "development";
  }

  // Client-side: strict localhost detection only
  return (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  );
};

/**
 * Gets the appropriate reCAPTCHA site key based on environment
 * @returns {string} reCAPTCHA site key
 */
export const getRecaptchaSiteKey = () => {
  const isDev = isLocalhost();

  if (isDev) {
    // Only use test key for true localhost development
    return (
      process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY_DEV ||
      "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
    );
  } else {
    // Use real production key for all other environments (builds, staging, production)
    return (
      process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY_PROD ||
      "6LfWVA8iAAAAAFERHAfJEDVMhwJ8axydb2Lcuy7j"
    );
  }
};
